import {
  Box,
  Button,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  useTheme, useMediaQuery
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { green } from '@material-ui/core/colors';
import { Formik } from 'formik';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomDialog from 'src/app/components/CustomDialog';
import { updateUser } from 'src/features/userSlice';
import * as Yup from 'yup';

const UpdateProfile = ({
  open,
  onClose,
  user,
  listAgencyBusiness,
  listProvinces
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [typeBusiness, setTypeBusiness] = useState('personal');

  const handleClose = () => {
    onClose();
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleSubmit = data => {
    if (!user || !user?.id) return;
    const newUser = {
      username: data.username,
      full_name: data.full_name,
      email: data.email,
      phone: data.phone,
      citizen_id: data.citizen_id,
      address: data.address,
      tax_code: typeBusiness === 'business' ? data.tax_code : null,
      business_id: typeBusiness === 'business' ? data.business_id : null,
      business_name: typeBusiness === 'business' ? data.business_name : null,
      dob: null
    };
    dispatch(updateUser({ id: user.id, data: newUser }));
    onClose();
  };

  return (
    <CustomDialog
      title="Chỉnh sửa người dùng"
      open={open}
      onClose={handleClose}
    >
      <div>
        <Formik
          initialValues={{
            username: user.username || '',
            full_name: user.full_name || '',
            email: user.email || '',
            phone: user.phone || '',
            citizen_id: user.citizen_id || '',
            business_id: user?.business?.id || 0,
            address: user.address || '',
            tax_code: user.tax_code || null,
            type: typeBusiness,
            business_name: user.business_name
          }}
          validationSchema={Yup.object().shape({
            username: Yup.string()
              .max(100)
              .matches(/^\S+$/, 'Tên đăng nhập không được chứa khoảng trắng')
              .matches(
                /^[a-zA-Z0-9_]+$/,
                'Tên đăng nhập không được chứa ký tự đặc biệt'
              ),
            full_name: Yup.string().max(100),
            email: Yup.string().email('Email chưa đúng định dạng'),
            phone: Yup.string().matches(
              /^(84|0[3|5|7|8|9])+([0-9]{8})$/,
              'Số điện thoại chưa đúng định dạng'
            ),
            address: Yup.string().max(100)
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tên người dùng <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.full_name && errors.full_name)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.full_name && errors.full_name}
                    margin="normal"
                    name="full_name"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.full_name}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Số điện thoại <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.phone && errors.phone)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.phone && errors.phone}
                    margin="normal"
                    name="phone"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.phone}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tên đăng nhập <span style={{ color: 'red' }}></span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.username && errors.username)}
                    fullWidth
                    className="input-no-fieldset"
                    helperText={touched.username && errors.username}
                    margin="normal"
                    size="small"
                    name="username"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel style={{ marginBottom: '21px' }}>
                    Tỉnh thành <span className="text-danger">*</span>
                  </InputLabel>
                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={listProvinces || []}
                    getOptionLabel={option => option.name}
                    value={(listProvinces || []).find(
                      option => option.id === Number(values.citizen_id)
                    )}
                    onChange={(e, value) =>
                      setFieldValue('citizen_id', JSON.stringify(value.id))
                    }
                    disableClearable
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn tỉnh thành"
                        name="citizen_id"
                        error={Boolean(touched.citizen_id && errors.citizen_id)}
                        helperText={touched.citizen_id && errors.citizen_id}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px'
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Địa chỉ <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.address && errors.address)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.address && errors.address}
                    margin="normal"
                    name="address"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.address}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Email <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    margin="normal"
                    className="input-no-fieldset"
                    name="email"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    variant="outlined"
                  />
                </Grid>{' '}
                
                {typeBusiness === 'business' && (
                  <>
                  <Grid item md={6} xs={12}>
                      <InputLabel>
                        Tên doanh nghiệp<span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <TextField
                        error={Boolean(touched.tax_code && errors.tax_code)}
                        fullWidth
                        helperText={touched.tax_code && errors.tax_code}
                        margin="normal"
                        className="input-no-fieldset"
                        name="business_name"
                        size="small"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.business_name}
                        variant="outlined"
                      />
                    </Grid>{' '}
                     <Grid item md={6} xs={12}>
                      <InputLabel>
                        Mã số thuế<span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <TextField
                        error={Boolean(touched.tax_code && errors.tax_code)}
                        fullWidth
                        helperText={touched.tax_code && errors.tax_code}
                        margin="normal"
                        className="input-no-fieldset"
                        name="tax_code"
                        size="small"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.tax_code}
                        variant="outlined"
                      />
                    </Grid>{' '}
                    <Grid item md={6} xs={12}>
                      <InputLabel style={{ marginBottom: '21px' }}>
                        Loại hình kinh doanh{' '}
                        <span style={{ color: 'red' }}></span>
                      </InputLabel>
                      <Autocomplete
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        size="small"
                        options={listAgencyBusiness || []}
                        getOptionLabel={option => option.title}
                        value={(listAgencyBusiness || []).find(
                          option => option.id === values.business_id
                        )}
                        onChange={(e, value) =>
                          setFieldValue('business_id', value.id)
                        }
                        disableClearable
                        renderInput={params => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Chọn loại hình kinh doanh"
                            name="business_id"
                            error={Boolean(
                              touched.business_id && errors.business_id
                            )}
                            helperText={
                              touched.business_id && errors.business_id
                            }
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                fontSize: '16px',
                                padding: '0 8px',
                                height: '35px'
                              }
                            }}
                          />
                        )}
                        className={classes.customOutline}
                      />
                    </Grid>{' '}
                  </>
                )}

                <Grid item md={6} xs={12}>
                  <RadioGroup
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'row',
                      marginTop: '32px'
                    }}
                    aria-label="time"
                    name="type"
                    value={values.type}
                    onChange={e => {
                      setFieldValue('type', e.target.value);
                      setTypeBusiness(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="personal"
                      control={<Radio />}
                      label="Cá nhân"
                    />
                    <FormControlLabel
                      value="business"
                      control={<Radio />}
                      label="Doanh nghiệp"
                    />
                  </RadioGroup>
                </Grid>{' '}
              </Grid>
              <Box my={3}>
                <div className={classes.groupButtonSubmit}>
                  <div className={classes.wrapper}>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 90 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      onClick={() => handleClose()}
                      className="btn-main btn-plain mx-3"
                      color="primary"
                      size="large"
                      variant="contained"
                    >
                      Thoát
                    </Button>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 120 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      className="btn-main mx-3"
                      color="primary"
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Chỉnh sửa
                    </Button>
                    {/* {statusCreate === STATUS_API.PENDING && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )} */}
                  </div>
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    }
  }
}));

export default React.memo(UpdateProfile);
